import { createApi } from "@reduxjs/toolkit/query/react"

import { ApiTypes, UITypes } from "types"

import { baseQueryWithAuth } from "utils/api"
import { prepareQueryParams } from "utils/prepareQueryParams"

export const alertsApi = createApi({
  reducerPath: "alerts",
  tagTypes: ["alerts"],
  baseQuery: baseQueryWithAuth,
  endpoints: builder => ({
    getAlerts: builder.query<ApiTypes.Res.Alerts, UITypes.Params>({
      query: arg => ({
        url: `/alerts`,
        method: "GET",
        params: prepareQueryParams(arg),
      }),
    }),
    getAlertStatusesWidget: builder.query<{ data: ApiTypes.Res.AlertStatusesWidget }, void>({
      query: () => ({
        url: `/alerts/statuses-widget`,
        method: "GET",
      }),
    }),
    getAlertTypesWidget: builder.query<{ data: ApiTypes.Res.AlertTypesWidget }, void>({
      query: () => ({
        url: `/alerts/types-widget`,
        method: "GET",
      }),
    }),
    getAlertAndDeviceWidget: builder.query<{ data: ApiTypes.Res.AlertsAndDeviceWidget }, void>({
      query: () => ({
        url: `/alerts/alerts-and-devices-widget`,
        method: "GET",
      }),
    }),
    getAlertsUnseenCount: builder.query<{ data: number }, { device_sn: string }>({
      query: arg => ({
        url: `/alerts/unseen-count`,
        method: "GET",
        params: prepareQueryParams({ device_sn: arg.device_sn }),
      }),
    }),
    postAlertFreeze: builder.mutation<ApiTypes.Model.Order, number[]>({
      query: ids => ({
        url: `/alerts/freeze`,
        method: "POST",
        body: {
          alerts: ids,
        },
      }),
    }),
    postAlertUnfreeze: builder.mutation<ApiTypes.Model.Order, number[]>({
      query: ids => ({
        url: `/alerts/activate`,
        method: "POST",
        body: {
          alerts: ids,
        },
      }),
    }),
    postAlertAcknowledge: builder.mutation<ApiTypes.Model.Order, ApiTypes.Req.AlertAcknowledge>({
      query: data => ({
        url: `/alerts/acknowledge`,
        method: "POST",
        body: {
          alerts: data.ids,
          until: data.until,
        },
      }),
    }),
  }),
})

export const {
  useLazyGetAlertsQuery,
  useLazyGetAlertStatusesWidgetQuery,
  useLazyGetAlertTypesWidgetQuery,
  useLazyGetAlertAndDeviceWidgetQuery,
  useLazyGetAlertsUnseenCountQuery,
  usePostAlertFreezeMutation,
  usePostAlertAcknowledgeMutation,
  usePostAlertUnfreezeMutation,
} = alertsApi
